import React, { useState } from 'react';
import { Button } from 'js/design_system/Button';
import { TextButton } from 'js/design_system/TextButton';
import ShareModal from './ShareModal';

type Props = {
  publishedLetter: {
    id: string | number;
    doi: string;
    work: {
      id: string | number;
      title: string;
      owner: {
        first_name: string;
        last_name: string;
      };
    };
    letter_submission: {
      authors: Array<{
        first_name: string;
        last_name: string;
      }>;
    };
    journal: {
      name: string;
    };
    share_summary?: string | null;
  };
  source: string;
  buttonClassName?: string;
  asTextButton?: boolean;
};

export const ShareButton: React.FC<Props> = ({
  publishedLetter,
  source,
  buttonClassName,
  asTextButton = false,
}) => {
  const [openModal, setOpenModal] = useState(false);

  const openShareModal = () => {
    setOpenModal(true);
  };

  const closeShareModal = () => {
    setOpenModal(false);
  };

  const ButtonComponent = asTextButton ? TextButton : Button;
  const additionalButtonComponentProps = asTextButton
    ? { inline: true }
    : { secondary: true };

  return (
    <>
      <ButtonComponent
        onClick={openShareModal}
        icon="share"
        className={buttonClassName}
        {...additionalButtonComponentProps}
      >
        Share
      </ButtonComponent>
      <ShareModal
        open={openModal}
        publishedLetter={publishedLetter}
        onClose={closeShareModal}
        source={source}
      />
    </>
  );
};
